import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import {
  Box,
  Container,
} from '@mui/material';
import GroupSettingControl from "applications/signal/components/GroupSettingControl";
import { isEditorAuthorization } from "applications/signal/utils/authUtils";
import { useAuth } from "hooks/useAuth";

export default function SignalLayout() {
  const navigate = useNavigate();
  const { signalUser } = useAuth();

  useEffect(() => {
    if (signalUser && !signalUser.service_agreement) {
      navigate("/signal/terms_of_service");
    }
  }, [signalUser, navigate]);

  return (
    <>
      {
        signalUser ?
          <>
            <h1 onClick={() => navigate("/signal")}>買いログSignal</h1>
            {
              isEditorAuthorization(signalUser) ?
                <GroupSettingControl />
                : null
            }
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                mt: 2,
              }}
            >
              <Container
                maxWidth="xl"
                sx={{
                  backgroundColor: "#fff",
                  padding: 4,
                  borderRadius: 2,
                  boxShadow: 3,
                  // position: "relative",
                }}
              >
                <Outlet />
              </Container>
            </Box>
          </>

        : <div>Signalの利用権限がありません。管理者にお問い合わせください。</div>
      }
    </>
  )
}
